// extracted by mini-css-extract-plugin
export default {"Work":"Work_Work__SA1E9","Timeline":"Work_Timeline__SOlPm","Year":"Work_Year__lhFFw","Tech":"Work_Tech__3JSgp"};